import moment from "moment";
import React from "react";
import { TBFL2Record } from "../../../../../redux/app/bfl-2/@types";
import { TBFL2A1 } from "../../../../../redux/app/bfl-2/groups/bfl2-a";
import { commonUtils } from "../../../../../redux/_common";
import Biofouling2TableRows from "../BioTableRows";

type OwnProps = {
	biofoulingRecord: TBFL2Record;
	isStrikedOff?: boolean;
};
type BFL2A1PreviewProps = OwnProps;
function BFL2A1Preview(props: BFL2A1PreviewProps) {
	const biofoulingRecord = props.biofoulingRecord as TBFL2A1;
	const operationDate = moment(
		biofoulingRecord.selectedDate,
		"YYYY-MM-DD"
	).format("DD-MMM-YYYY");

	function renderMain() {
		return (
			<Biofouling2TableRows
				record={biofoulingRecord}
				tableRows={[
					[operationDate, "A", 1, renderItem1()],
					[null, null, 2, renderItem2()],
					[null, null, 3, renderItem3()],
					[null, null, 4, renderItem4()],
					[null, null, "NOTE", biofoulingRecord.remarks],
				]}
			/>
		);
	}

	function renderItem1() {
		return (
			<h4 className="font-medium uppercase">
				{biofoulingRecord.item1.durationAndDates
					? biofoulingRecord.item1.durationAndDates
					: "-----"}
			</h4>
		);
	}
	function renderItem2() {
		return (
			<h4 className="font-medium uppercase">
				{biofoulingRecord.item2.reasonForDeparture
					? biofoulingRecord.item2.reasonForDeparture
					: "-----"}
			</h4>
		);
	}
	function renderItem3() {
		return (
			<h4 className="font-medium uppercase">
				{biofoulingRecord.item3.contingencyActions
					? biofoulingRecord.item3.contingencyActions
					: "-----"}
			</h4>
		);
	}
	function renderItem4() {
		return (
			<>
				{biofoulingRecord.item4.dateSMT ? (
					<h4 className="font-medium uppercase">
						{moment(biofoulingRecord.item4.dateSMT).format("DD-MMM-YYYY")} (SMT)
					</h4>
				) : null}

				{biofoulingRecord.item4.timeSMT ? (
					<h4 className="font-medium uppercase">
						{biofoulingRecord.item4.timeSMT} (SMT)
					</h4>
				) : null}
				{biofoulingRecord.item4.operationPlace.place === "IN_PORT" &&
				biofoulingRecord.item4.operationPlace.portName ? (
					<>{biofoulingRecord.item4.operationPlace.portName} PORT</>
				) : (
					"-----"
				)}
				{biofoulingRecord.item4.operationPlace.place === "AT_SEA" &&
				biofoulingRecord.item4.operationPlace.startPosition.latitude ? (
					<>
						Lat{" "}
						{biofoulingRecord.item4.operationPlace.startPosition.latitude
							? biofoulingRecord.item4.operationPlace.startPosition.latitude
							: "-----"}{" "}
						/ Long{" "}
						{biofoulingRecord.item4.operationPlace.startPosition.longitude
							? biofoulingRecord.item4.operationPlace.startPosition.longitude
							: "-----"}
					</>
				) : null}
			</>
		);
	}

	return renderMain();
}

export default BFL2A1Preview;
